import React from 'react';

const LocationIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 8.995 13.492'
      {...props}
    >
      <path
        className='subheader__container-link-icon'
        d='M4.497 0A4.5 4.5 0 00.54 6.635l3.711 6.713a.281.281 0 00.492 0l3.713-6.715A4.5 4.5 0 004.497 0zm0 6.746A2.249 2.249 0 116.746 4.5a2.251 2.251 0 01-2.249 2.246z'
        fill='#fff'
      />
    </svg>
  );
};

export default LocationIcon;
